// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plans-dialog-root .MuiBackdrop-root,
.plans-dialog-backdrop {
  background-color: rgba(15, 23, 42, 0.45) !important;
}

/* Kill every MUI scroll surface on this dialog */
.plans-dialog-root.MuiDialog-root,
.plans-dialog-root .MuiDialog-container,
.plans-dialog-root .MuiDialog-paper,
.plans-dialog-paper {
  overflow: hidden !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}

.plans-dialog-root .MuiDialog-container {
  align-items: center !important;
}

.plans-dialog-paper {
  border-radius: 18px !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;
  max-width: 920px !important;
  max-height: none !important;
  height: auto !important;
  display: flex !important;
  flex-direction: column !important;
}

.plans-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 22px 8px;
  border-bottom: 1px solid #eef2f7;
  flex-shrink: 0;
}

.plans-dialog-heading {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.03em;
  line-height: 1.2;
}

.plans-dialog-subtitle {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.35;
}

.plans-dialog-subtitle strong {
  color: #0f172a;
  font-weight: 600;
}

.plans-dialog-locked {
  color: #b45309;
  font-weight: 600;
}

.plans-dialog-close {
  color: #64748b !important;
  margin-top: -4px;
}

.plans-dialog-body {
  padding: 14px 20px 10px;
  background: #f8fafc;
  overflow: hidden !important;
  flex: 0 0 auto;
}

.plans-dialog-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  align-items: stretch;
}

@media (max-width: 760px) {
  .plans-dialog-grid {
    grid-template-columns: 1fr;
  }

  .plans-dialog-root .MuiDialog-paper,
  .plans-dialog-paper {
    max-height: 92vh !important;
    overflow-y: auto !important;
  }
}

.plans-dialog-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.plans-dialog-card.current {
  border-color: #07a6ef;
  box-shadow:
    0 0 0 2px rgba(7, 166, 239, 0.2),
    0 8px 24px rgba(7, 166, 239, 0.1);
}

.plans-dialog-card-top {
  padding: 12px 14px 10px;
  border-bottom: 1px solid #f1f5f9;
}

.plans-dialog-card.current .plans-dialog-card-top {
  background: linear-gradient(180deg, #f0f9ff 0%, #ffffff 100%);
}

.plans-dialog-card-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 24px;
  margin-bottom: 6px;
}

.plans-dialog-card h3 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.plans-dialog-badge {
  flex-shrink: 0;
  background: #07a6ef;
  color: #fff;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 3px 7px;
  border-radius: 999px;
  line-height: 1;
}

.plans-dialog-price {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-height: 42px;
}

.plans-dialog-price-main {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.04em;
  line-height: 1.15;
}

.plans-dialog-price-sub {
  font-size: 0.72rem;
  font-weight: 500;
  color: #64748b;
  line-height: 1.3;
}

.plans-dialog-features {
  margin: 0;
  padding: 2px 14px 8px;
  display: flex;
  flex-direction: column;
}

.plans-dialog-feature {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  column-gap: 10px;
  align-items: center;
  min-height: 28px;
  border-bottom: 1px solid #f1f5f9;
}

.plans-dialog-feature:last-child {
  border-bottom: none;
}

.plans-dialog-feature dt {
  margin: 0;
  color: #64748b;
  font-size: 0.74rem;
  font-weight: 500;
  white-space: nowrap;
}

.plans-dialog-feature dd {
  margin: 0;
  color: #0f172a;
  font-size: 0.78rem;
  font-weight: 600;
  text-align: right;
  line-height: 1.25;
  word-break: break-word;
}

.plans-dialog-actions {
  padding: 12px 20px 16px !important;
  margin: 0 !important;
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 10px;
  flex-wrap: wrap;
  border-top: 1px solid #eef2f7;
  background: #fff;
  flex-shrink: 0;
}

.plans-dialog-btn-secondary {
  text-transform: none !important;
  font-weight: 600 !important;
  color: #334155 !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 10px !important;
  padding: 6px 12px !important;
}

.plans-dialog-btn-primary {
  text-transform: none !important;
  font-weight: 600 !important;
  background: #07a6ef !important;
  border-radius: 10px !important;
  padding: 6px 14px !important;
  box-shadow: none !important;
}

.plans-dialog-btn-primary:hover {
  background: #0596d8 !important;
}

.plans-dialog-footnote {
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.35;
}
`, "",{"version":3,"sources":["webpack://./src/Css/PlansDialog.css"],"names":[],"mappings":"AAAA;;EAEE,mDAAmD;AACrD;;AAEA,iDAAiD;AACjD;;;;EAIE,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yDAAyD;EACzD,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB;;qCAEmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,wBAAwB;EACxB,oCAAoC;EACpC,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".plans-dialog-root .MuiBackdrop-root,\n.plans-dialog-backdrop {\n  background-color: rgba(15, 23, 42, 0.45) !important;\n}\n\n/* Kill every MUI scroll surface on this dialog */\n.plans-dialog-root.MuiDialog-root,\n.plans-dialog-root .MuiDialog-container,\n.plans-dialog-root .MuiDialog-paper,\n.plans-dialog-paper {\n  overflow: hidden !important;\n  overflow-x: hidden !important;\n  overflow-y: hidden !important;\n}\n\n.plans-dialog-root .MuiDialog-container {\n  align-items: center !important;\n}\n\n.plans-dialog-paper {\n  border-radius: 18px !important;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;\n  max-width: 920px !important;\n  max-height: none !important;\n  height: auto !important;\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n.plans-dialog-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 22px 8px;\n  border-bottom: 1px solid #eef2f7;\n  flex-shrink: 0;\n}\n\n.plans-dialog-heading {\n  margin: 0;\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n}\n\n.plans-dialog-subtitle {\n  margin: 4px 0 0;\n  font-size: 0.85rem;\n  color: #64748b;\n  line-height: 1.35;\n}\n\n.plans-dialog-subtitle strong {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.plans-dialog-locked {\n  color: #b45309;\n  font-weight: 600;\n}\n\n.plans-dialog-close {\n  color: #64748b !important;\n  margin-top: -4px;\n}\n\n.plans-dialog-body {\n  padding: 14px 20px 10px;\n  background: #f8fafc;\n  overflow: hidden !important;\n  flex: 0 0 auto;\n}\n\n.plans-dialog-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  align-items: stretch;\n}\n\n@media (max-width: 760px) {\n  .plans-dialog-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .plans-dialog-root .MuiDialog-paper,\n  .plans-dialog-paper {\n    max-height: 92vh !important;\n    overflow-y: auto !important;\n  }\n}\n\n.plans-dialog-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.plans-dialog-card.current {\n  border-color: #07a6ef;\n  box-shadow:\n    0 0 0 2px rgba(7, 166, 239, 0.2),\n    0 8px 24px rgba(7, 166, 239, 0.1);\n}\n\n.plans-dialog-card-top {\n  padding: 12px 14px 10px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.plans-dialog-card.current .plans-dialog-card-top {\n  background: linear-gradient(180deg, #f0f9ff 0%, #ffffff 100%);\n}\n\n.plans-dialog-card-name-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 24px;\n  margin-bottom: 6px;\n}\n\n.plans-dialog-card h3 {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n}\n\n.plans-dialog-badge {\n  flex-shrink: 0;\n  background: #07a6ef;\n  color: #fff;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  padding: 3px 7px;\n  border-radius: 999px;\n  line-height: 1;\n}\n\n.plans-dialog-price {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-height: 42px;\n}\n\n.plans-dialog-price-main {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.04em;\n  line-height: 1.15;\n}\n\n.plans-dialog-price-sub {\n  font-size: 0.72rem;\n  font-weight: 500;\n  color: #64748b;\n  line-height: 1.3;\n}\n\n.plans-dialog-features {\n  margin: 0;\n  padding: 2px 14px 8px;\n  display: flex;\n  flex-direction: column;\n}\n\n.plans-dialog-feature {\n  display: grid;\n  grid-template-columns: 92px minmax(0, 1fr);\n  column-gap: 10px;\n  align-items: center;\n  min-height: 28px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.plans-dialog-feature:last-child {\n  border-bottom: none;\n}\n\n.plans-dialog-feature dt {\n  margin: 0;\n  color: #64748b;\n  font-size: 0.74rem;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.plans-dialog-feature dd {\n  margin: 0;\n  color: #0f172a;\n  font-size: 0.78rem;\n  font-weight: 600;\n  text-align: right;\n  line-height: 1.25;\n  word-break: break-word;\n}\n\n.plans-dialog-actions {\n  padding: 12px 20px 16px !important;\n  margin: 0 !important;\n  display: flex !important;\n  justify-content: flex-end !important;\n  align-items: center !important;\n  gap: 10px;\n  flex-wrap: wrap;\n  border-top: 1px solid #eef2f7;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.plans-dialog-btn-secondary {\n  text-transform: none !important;\n  font-weight: 600 !important;\n  color: #334155 !important;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 10px !important;\n  padding: 6px 12px !important;\n}\n\n.plans-dialog-btn-primary {\n  text-transform: none !important;\n  font-weight: 600 !important;\n  background: #07a6ef !important;\n  border-radius: 10px !important;\n  padding: 6px 14px !important;\n  box-shadow: none !important;\n}\n\n.plans-dialog-btn-primary:hover {\n  background: #0596d8 !important;\n}\n\n.plans-dialog-footnote {\n  font-size: 0.8rem;\n  color: #64748b;\n  line-height: 1.35;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
